// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"6b98b1aa","76":"206f4378","148":"cb65434c","249":"cea4701f","345":"2b3386e3","488":"c9a9094c","593":"5e2fc08a","728":"8deda5dc","789":"f29bb685","844":"077934b7"}[chunkId] + ".chunk.js";
};